import { render, staticRenderFns } from "./Blacklist.vue?vue&type=template&id=5bdd6050&scoped=true"
import script from "./Blacklist.vue?vue&type=script&lang=js"
export * from "./Blacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdd6050",
  null
  
)

export default component.exports